// Façade for the screen-share annotation overlay window.
// On Electron: routes to main-process IPC → creates a transparent, click-through
// BrowserWindow on the captured monitor.
// On Web: NO popout. Opening a separate window-bound socket caused the
// sidebar voice-roster to mis-attribute the popout's disconnect (on stop-share)
// to the main user "leaving" the channel — user disappeared from the channel
// roster on stop-share until refresh (regression in 1.1.209A, fixed in next
// patch). In-app preview tile (ScreenShareAnnotation) has the full annotation
// toolset post-refactor and is sufficient for web. Real-desktop overlay is an
// Electron-only feature.

import type { ScreenOverlayOpenArgs as OpenArgs } from '../types/electron'

const isElectronOverlay = (): boolean =>
  typeof window !== 'undefined' && !!window.electronAPI?.screenOverlay

export const screenOverlayClient = {
  async open(args: OpenArgs): Promise<void> {
    if (isElectronOverlay()) {
      try {
        await window.electronAPI!.screenOverlay!.create(args)
      } catch (err) {
        console.error('[screenOverlay] electron create failed', err)
      }
      return
    }
    // Web: no popout (see file header). In-app preview tile carries the
    // full annotation toolset post-refactor.
    console.info('[screenOverlay] web sharer — using in-app preview tile (popout disabled)')
  },

  async close(): Promise<void> {
    if (isElectronOverlay()) {
      try {
        await window.electronAPI!.screenOverlay!.close()
      } catch (err) {
        console.error('[screenOverlay] electron close failed', err)
      }
    }
    // Web: nothing to close (no popout was opened).
  },

  async setAnnotateMode(active: boolean): Promise<void> {
    if (isElectronOverlay()) {
      try {
        await window.electronAPI!.screenOverlay!.setIgnoreMouse(!active)
      } catch (err) {
        console.error('[screenOverlay] electron setIgnoreMouse failed', err)
      }
    }
    // Web: no-op (no popout window to toggle click-through on).
  },
}
